import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from "../../shared/helpers/commons";

export const getActiveServices = (filters, token) => {
    const requestHeaders = {
        ...headers,
        Authorization: `Bearer ${token}`
    };
    const url = `${api}/activeservices?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// GPS Summary
export const getGpsSummary = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/summary/gps?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// GPS Report
export const getGpsReport = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token   // ← token enviado en header custom
    };
    const url = `${api}/inventory/gps?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// Tickets Summary
export const getTicketsSummary = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token   // ← token enviado en header custom
    };

    const url = `${api}/inventory/summary/tickets?${makeQuery(filters)}`;

    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
    });
};


// Simcards Report
export const getSimcardsReport = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/simcards?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// Devices Report
export const getDevicesReport = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/devices?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// Export GPS Summary
export const exportGpsSummary = (filters, format, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/summary/gps/export/${format}?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};

// Export Tickets Summary
export const exportTicketsSummary = (filters, format, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/summary/tickets/export/${format}?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};

// Export GPS Report
export const exportGpsReport = (filters, format, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/gps/export/${format}?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};

// Export Simcards Report
export const exportSimcardsReport = (filters, format, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/simcards/export/${format}?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};

// Export Devices Report
export const exportDevicesReport = (filters, format, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/devices/export/${format}?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};

// Agencies (for city selector)
export const getAgencies = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'X-Access-Token': token
    };
    const url = `${api}/agencies?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// Companies (for company selector in reports)
export const getCompaniesReports = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'X-Access-Token': token
    };
    const url = `${api}/companies?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders
    });
};

// Export Unified Inventory Report (Tickets + GPS + Simcards + Devices)
export const exportInventoryReport = (filters, token) => {
    const requestHeaders = {
        ...headers,
        'x-access-token': token
    };
    const url = `${api}/inventory/export?${makeQuery(filters)}`;
    return axios({
        method: 'get',
        url,
        headers: requestHeaders,
        responseType: 'blob'
    });
};